module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-frowningface-smile-svgrepo-com.d357e768.svg";